import React from 'react';
import { Helmet }  from "react-helmet"

const MetaTags = props => {

    const { title, description, url, image } = props

    return ( 
        <Helmet>
            <title>{title}</title>
            <link rel="canonical" href={url}/>
            <meta name="description" content={description} />

            <meta itemprop="name" content={title} />
            <meta itemprop="description" content={description} /> 
            <meta itemprop="image" content={image}/>

            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image}/>

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image}/>
        </Helmet>
     );
}
 
export default MetaTags;